import NumberStepper from '../../../../components/NumberStepper/NumberStepper';
import { getAiSpaceCount } from '../../listingDisplay';

export default function MaxSpotsSection({
    listing,
    editMode = false,
    dirtyFields,
    baselineFields,
    setDirtyFields,
    fieldErrors = {},
}) {
    const geoCount = getAiSpaceCount(listing);
    const spots = editMode && dirtyFields
        ? Number(dirtyFields.maxSpots)
        : (listing.pricing?.maxSpots ?? geoCount ?? null);

    if (!editMode || !dirtyFields) {
        if (spots == null) return null;
        return (
            <div className="host-panel-section">
                <div className="host-panel-section-label">Maximum Truck Parking Spots</div>
                <div className="host-summary-value">{spots}</div>
            </div>
        );
    }

    const helperText = geoCount != null
        ? `Geofence area suggests ${geoCount} spots. You can override — manual values stick across geofence changes.`
        : 'You can override the spot count; manual values stick across geofence changes.';

    const changeSpots = (next) => {
        const clamped = Math.min(2000, Math.max(10, next));
        setDirtyFields((prev) => ({
            ...prev,
            maxSpots: clamped,
            maxSpotsLocked: true,
        }));
    };

    return (
        <div className="host-panel-section">
            <NumberStepper
                label="Maximum Truck Parking Spots"
                required
                value={Number(dirtyFields.maxSpots) || 250}
                onChange={changeSpots}
                parseInput={(text) => parseInt(text.replace(/\D/g, ''), 10)}
                onDecrement={() => changeSpots(Number(dirtyFields.maxSpots) - 10)}
                onIncrement={() => changeSpots(Number(dirtyFields.maxSpots) + 10)}
                helperText={helperText}
                aiSuggestion={geoCount}
                onUseAiSuggestion={changeSpots}
            />
            {fieldErrors.maxSpots && (
                <div className="drawer-field-error">{fieldErrors.maxSpots}</div>
            )}
        </div>
    );
}
